<template>
    <MenuPage />
    <Dialog v-model:visible="spinnervisible" modal :closable="false" class="alrt">
        <div>
            <ProgressSpinner style="width: 50px; height: 50px; display: block; margin: auto;" strokeWidth="8"
                fill="transparent" animationDuration=".5s" aria-label="Custom ProgressSpinner" />

            <p>Cargando Ordenes</p>
        </div>
    </Dialog>


    <Dialog v-model:visible="adjuntar" modal header="Adjunta Evidencia">
        <FileUpload name="demo[]" :custom-upload="true" @uploader="AdjuntarEvidencia($event)" :multiple="false"
            :maxFileSize="100000000">
            <template #empty>
                <span>Arrastra los archivos aqui para subirlos.</span>
            </template>
        </FileUpload>
    </Dialog>


    <Dialog v-model:visible="mostrarhistorial" modal class="modal_info">
        <p style="font-size: 14px; font-weight:bold;">Historial de movimientos</p>
        <p style="font-size: 12px;">Entrada a almacen indeasa</p>
        <p style="font-size: 12px;"><b>Fecha: </b>{{ MostrarMovimientos.fecha_entrada }}</p>
        <p style="font-size: 12px;"><b>Orden: </b>{{ MostrarMovimientos.numero_orden_1 }}</p>
        <hr>
        <p style="font-size: 12px;">Entrada a almacen apizaco</p>
        <p style="font-size: 12px;"><b>Fecha: </b>{{ MostrarMovimientos.fecha_apizaco }}</p>
        <p style="font-size: 12px;"><b>Orden: </b>{{ MostrarMovimientos.numero_orden_2 }}</p>
        <p style="font-size: 12px;"><b>usuario: </b>{{ MostrarMovimientos.usuario_crea_apizaco }}</p>
        <p style="font-size: 12px;" v-if="MostrarMovimientos.numero_orden_2 !== null"><b>porcentaje que ingresa: </b>{{
            MostrarMovimientos.porcentaje_entrada_apizaco }}%</p>
        <hr>
        <p style="font-size: 12px;">Llendo</p>
        <p style="font-size: 12px;"><b>Fecha: </b>{{ MostrarMovimientos.fecha_llenado }}</p>
        <p style="font-size: 12px;"><b>usuario: </b>{{ MostrarMovimientos.usuario_llena }}</p>
        <hr>
        <p style="font-size: 12px;">Salida a Almacen</p>
        <p style="font-size: 12px;"><b>Fecha: </b>{{ MostrarMovimientos.fecha_retorno }}</p>
        <p style="font-size: 12px;"><b>Orden: </b>{{ MostrarMovimientos.numero_orden_3 }}</p>
        <p style="font-size: 12px;"><b>usuario: </b>{{ MostrarMovimientos.usuario_retorna }}</p>
        <p style="font-size: 12px;" v-if="MostrarMovimientos.numero_orden_3 !== null"><b>Porcentaje que sale: </b>{{
            MostrarMovimientos.porcentaje_salida }}%</p>
        <hr>
        <div v-if="MostrarMovimientos.factura !== null">
            <p style="font-size: 12px;" >Salida a Cliente</p>
            <p style="font-size: 12px;"><b>Fecha: </b>{{ MostrarMovimientos.fecha_entrega_cliente }}</p>
            <p style="font-size: 12px;"><b>Orden: </b>{{ MostrarMovimientos.numero_orden_4 }}</p>
            <p style="font-size: 12px;"><b>Usuario: </b>{{ MostrarMovimientos.usuario_crea_salida }}</p>
            <p style="font-size: 12px;"><b>Factura:</b></p>
            <a :href="`https://api.appindeasa.com/${MostrarMovimientos.factura}`" target="_blank" rel="noopener">
                Ver archivo
            </a>
            <p style="font-size: 12px;"><b>Evidencia Cliente:</b></p>
            <a :href="`https://api.appindeasa.com/${MostrarMovimientos.evidencia}`" target="_blank" rel="noopener"
                v-if="MostrarMovimientos.evidencia !== null">
                Ver archivo
            </a>
            <div class="btn btn-primary" @click="Subirevidencia(MostrarMovimientos.Id)" v-else>Subir evidencia</div>
        </div>
        
    </Dialog>


    <Dialog v-model:visible="showdetalles" modal class="modal_info">
        <DataTable :value="detalles" dataKey="Id" paginator :rows="10" scrollable scrollHeight="40vh">

            <Column headerStyle="width:3rem">
                <template #body="{ data }">
                    <Checkbox @change="Checkstatus(`${data.Estatus}`)" v-model="puntos" :value="data" />
                </template>
            </Column>




            <Column field="Numero_unico" header="Número único" style="min-width:12rem">

                <!-- Contenido de la celda -->
                <template #body="{ data }">
                    <div class="item-number" v-tooltip.bottom="'Ver movimientos'" @click="MostrarMovimientosItem(data)">
                        {{ data.Numero_unico }}
                    </div>
                </template>
            </Column>

            <Column field="cliente" header="Cliente" style="min-width:12rem">
                <template #body="{ data }">
                    {{ data.razon_social }}
                </template>
            </Column>

            <Column field="Almacen_actual" header="Almacen" style="min-width:12rem">
                <template #body="{ data }">
                    {{ data.Almacen_actual }}
                </template>
            </Column>

            <Column field="Estatus" header="Estatus" style="min-width:12rem">
                <template #body="{ data }">
                    <div class="customfilter" :class="{
                        bg_admin: data.Estatus === 'vacio',
                        bg_operador: data.Estatus === 'lleno',
                        bg_facturacion: data.Estatus === 'completo'
                    }">
                        {{ data.Estatus }}
                    </div>
                </template>
            </Column>
        </DataTable>
    </Dialog>



    <div>
        <div class="content">
            <DataTable v-model:filters="filters" :value="orders" paginator :rows="7" dataKey="id" filterDisplay="row"
                scrollable scrollHeight="60vh" :globalFilterFields="['No_Orden', 'cliente', 'producto']">

                <template #header>
                    <div class="table-header">
                        <Button label="Nueva Orden" icon="pi pi-plus" class="p-button-success" @click="OpenModal" />
                    </div>
                </template>

                <Column header="Acciones">
                    <template #body="{ data }">
                        <Button type="button" icon="pi pi-ellipsis-v" @click="onButtonClick($event, data)"
                            aria-haspopup="true" aria-controls="overlay_menu" />
                        <Menu :model="items" :popup="true" v-model:popup="show" appendTo="body" ref="menuRef" />
                    </template>
                </Column>

                <!-- Columna: Nombre -->
                <Column field="No_Orden" header="Numero Orden" style="min-width: 12rem" :filter="true"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar por Orden..." />
                    </template>
                </Column>

                <!-- Columna: Correo -->
                <Column field="cliente" header="Cliente" style="min-width: 12rem" :filter="true"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar por cliente..." />
                    </template>
                </Column>

                <Column field="producto" header="Producto" style="min-width: 12rem" :filter="true"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar por producto..." />
                    </template>
                </Column>

                <!-- Columna: Teléfono -->
                <Column field="cantidad" header="Cantidad" style="min-width: 12rem">
                    <template #body="{ data }">
                        {{ data.cantidad }}
                    </template>
                </Column>

                <Column field="estatus" header="Estatus" style="min-width: 12rem">
                    <template #body="{ data }">
                        <div class="customfilter"
                            :class="{ bg_open: data.estatus == 'abierta', bg_transit: data.estatus == 'transito', bg_process: data.estatus == 'proceso', bg_finish: data.estatus === 'completo' }">
                            {{ data.estatus }}
                        </div>
                    </template>
                </Column>

                <!-- Columna: Acciones -->

            </DataTable>

            <Dialog v-model:visible="visible2" modal header="Editar Usuario" class="cont-50">

                <div class="container">
                    <div class="col-12 m-t-12">
                        <Select v-model="cliente" :options="clientes" optionLabel="razon_social"
                            placeholder="Selecciona un cliente" class="cont-100" />
                    </div>
                    <div class="col-12 m-t-12">
                        <Select v-model="producto" :options="productos" optionLabel="Nombre"
                            placeholder="Selecciona un Producto" class="cont-100" />
                    </div>
                    <div class="col-12 m-t-12">
                        <FloatLabel variant="on" class="cont-100">
                            <InputText id="on_label" type="cantidad" class="cont-100" v-model="cantidad" />
                            <label for="on_label">ingresa cantidad</label>
                        </FloatLabel>
                    </div>
                    <div class="col-12 m-t-12">
                        <FloatLabel variant="on">
                            <Textarea id="over_label" v-model="notas" rows="5" cols="30" style="resize: none"
                                class="cont-100" />
                            <label for="over_label">Notas</label>
                        </FloatLabel>
                    </div>
                </div>


                <div class="d-block m-auto cont-95" style="margin-top: 12px;"><br>
                    <Button class="cont-100" raised severity="contrast" @click="updateOrden()" type="button"
                        label="Editar" icon="pi pi-user-plus" :loading="isloading2" />
                </div>
            </Dialog>

            <Dialog v-model:visible="visible" modal header="Agregar Orden" class="cont-50">

                <div class="container">
                    <div class="col-12 m-t-12">
                        <Select v-model="cliente" :options="clientes" optionLabel="razon_social"
                            placeholder="Selecciona un cliente" class="cont-100" />
                    </div>
                    <div class="col-12 m-t-12">
                        <Select v-model="producto" :options="productos" optionLabel="Nombre"
                            placeholder="Selecciona un Producto" class="cont-100" />
                    </div>
                    <div class="col-12 m-t-12">
                        <FloatLabel variant="on" class="cont-100">
                            <InputText id="on_label" type="cantidad" class="cont-100" v-model="cantidad" />
                            <label for="on_label">ingresa cantidad</label>
                        </FloatLabel>
                    </div>
                    <div class="col-12 m-t-12">
                        <FloatLabel variant="on">
                            <Textarea id="over_label" v-model="notas" rows="5" cols="30" style="resize: none"
                                class="cont-100" />
                            <label for="over_label">Notas</label>
                        </FloatLabel>
                    </div>
                </div>

                <br>
                <div class="d-block m-auto cont-95" style="margin-top: 12px;"><br>
                    <Button class="cont-100" raised severity="contrast" @click="CrearOrden()" type="button"
                        label="Guardar" icon="pi pi-check" :loading="isloading" />
                </div>
            </Dialog>

        </div>
    </div>
</template>


<script setup>
import { Dialog, ProgressSpinner, Button, FileUpload, FloatLabel, Select, InputText, DataTable, Column, Textarea } from 'primevue';
import { useToast } from 'vue-toastification';
import MenuPage from './MenuPage.vue';
import Menu from 'primevue/menu';
import { onMounted, ref, nextTick } from 'vue';
import api from '@/plugins/axios';

const adjuntar = ref(false);
const orders = ref([]);
const idorder = ref(0);
const productos = ref([]);
const clientes = ref([]);
const visible = ref(false);
const visible2 = ref(false);
const cliente = ref(null);
const producto = ref(null);
const notas = ref("");
const menuRef = ref(null);
const show = ref(false);
const spinnervisible = ref(false);
const actualorder = ref(null);
const toast = useToast();
const cantidad = ref(0);
const isloading = ref(false);
const isloading2 = ref(false);
const MostrarMovimientos = ref([]);
const mostrarhistorial = ref(false);
const filters = ref({
    global: { value: null, matchMode: 'contains' },
    No_Orden: { value: null, matchMode: 'contains' },
    cliente: { value: null, matchMode: 'contains' },
    producto: { value: null, matchMode: 'contains' },
});


const iditem = ref(0);
const detalles = ref([]);
const showdetalles = ref(false);

const items = ref([
    {
        label: 'Options',
        items: [
            {
                label: 'Editar',
                icon: 'pi pi-user-edit',
                command: () => {
                    if (actualorder.value.estatus === "abierta") {
                        idorder.value = actualorder.value.Id;
                        cantidad.value = actualorder.value.cantidad;
                        notas.value = actualorder.value.notas;

                        const cliente_seleccionado = clientes.value.find(emp => emp.razon_social === actualorder.value.cliente);
                        cliente.value = cliente_seleccionado;

                        const producto_seleccionado = productos.value.find(emp => emp.Nombre === actualorder.value.producto);
                        producto.value = producto_seleccionado;

                        visible2.value = true;
                    }
                    else if (actualorder.value.estatus === "proceso") {
                        toast.warning("La orden no se puede modificar por que ya esta en proceso");
                    }
                    else {
                        toast.warning("La orden no se puede modificar por que ya esta finalizada");
                    }
                }
            },
            {
                label: 'Detalles',
                icon: 'pi pi-info',
                command: () => {
                    CargarInformacion();
                }
            }
        ]
    }
]);
//#region Funciones de carga
const GetOrdenes = async () => {
    try {
        const res = await api.get("/orden/get");
        orders.value = [];
        for (let item of res.data) {
            orders.value.push({
                Id: item.Id,
                No_Orden: item.No_Orden,
                cantidad: item.Cantidad_Total,
                estatus: item.status,
                cliente: item.cliente.razon_social,
                producto: item.producto.Nombre,
                notas: item.Notas
            });
        }
        nextTick(() => {
            spinnervisible.value = false;
        });
    }
    catch (err) {
        console.error(err)
    }
}

const getClientes = async () => {
    try {
        const res = await api.get("/cliente/get");
        clientes.value = res.data.data ?? [];
    }
    catch (err) {
        console.error(err)
    }
}


const getProductos = async () => {
    try {
        const res = await api.get("/producto/get");
        productos.value = res.data;
    }
    catch (err) {
        console.error(err)
    }
}


const CargarInformacion = async () => {
    try {
        const res = await api.post("/orden/getitemforos", {
            Id: actualorder.value.Id
        });
        console.log(res.data)
        detalles.value = res.data;
        showdetalles.value = true;
    }
    catch (err) {
        console.error(err);
    }
}


const MostrarMovimientosItem = async (data) => {
    try {
        console.log(data)
        const res = await api.post("/orden/getinfoitem", {
            id: data.Id
        });
        console.log(res.data);
        MostrarMovimientos.value = res.data;
        mostrarhistorial.value = true;
    }
    catch (err) {
        console.error(err);
    }
}
//#endregion



//#region funciones de sistema

const OpenModal = () => {
    visible.value = true;
}

const CrearOrden = async () => {
    try {

        if (cliente.value === null) {
            toast.error('Selecciona un cliente para continuar');
            return false;
        }
        if (producto.value === null) {
            toast.error('Selecciona un producto para continuar');
            return false;
        }
        if (cantidad.value === 0) {
            toast.error('No puedes continuar sin colocor al menos 1 en cantidad');
            return false;
        }
        isloading.value = true;
        const data = {
            "cliente_id": cliente.value.id,
            "producto_id": producto.value.id,
            "Cantidad_Total": cantidad.value,
            "Notas": notas.value,
            "Usuario_crea": localStorage.getItem("nombre")
        };
        const res = await api.post("/orden/store", data);
        console.log(res.data)
        if (res.data.response === "success") {
            producto.value = null;
            cliente.value = null;
            cantidad.value = 0;
            notas.value = "";
            toast.success("Se ha creado la orden con exito");
            visible.value = false;
            spinnervisible.value = true;
            isloading.value = false;
            await GetOrdenes();
        }
    }
    catch (err) {
        console.error(err);
    }
}

const updateOrden = async () => {
    try {

        if (cliente.value === null) {
            toast.error('Selecciona un cliente para continuar');
            return false;
        }
        if (producto.value === null) {
            toast.error('Selecciona un producto para continuar');
            return false;
        }
        if (cantidad.value === 0) {
            toast.error('No puedes continuar sin colocor al menos 1 en cantidad');
            return false;
        }
        console.log(idorder.value)
        isloading2.value = true;
        const data = {
            "cliente_id": cliente.value.id,
            "producto_id": producto.value.id,
            "Cantidad_Total": cantidad.value,
            "id": idorder.value,
            "Notas": notas.value
        };
        const res = await api.post("/orden/update", data);
        console.log(res.data)
        if (res.data.response === "success") {
            producto.value = null;
            cliente.value = null;
            cantidad.value = 0;
            notas.value = "";
            toast.success("Se ha actualizado la orden con exito");
            visible2.value = false;
            spinnervisible.value = true;
            isloading.value = false;
            await GetOrdenes();
        }
        else {
            toast.error(res.data)
        }
    }
    catch (err) {
        console.error(err);
    }
}


const onButtonClick = (event, data) => {
    actualorder.value = data;
    show.value = true
    menuRef.value?.toggle(event) // ahora el menú sabe dónde aparecer
}


const Subirevidencia = (id) => {
    iditem.value = id;
    adjuntar.value = true;
}


const AdjuntarEvidencia = async (event) => {
    console.log("Archivos seleccionados:", event.files);
    const archivo = event.files[0];

    try {
        let form = new FormData();
        form.append("evidencia", archivo);
        form.append("Id", iditem.value);
        const res = await api.post("/orden/subirevidencia", form);
        console.log(res.data)
        if (res.data.estatus === 'success') {
            adjuntar.value = false;
            toast.success("Archivo subido con exito");
            showdetalles.value = false;
            mostrarhistorial.value = false;
            await GetOrdenes();
        }
    }
    catch (err) {
        console.error(err);
    }
}
//#endregion
onMounted(async () => {
    spinnervisible.value = true;
    await GetOrdenes();
    await getProductos();
    await getClientes();
})
</script>


<style scoped>
.customfilter {
    width: 100px;
    border-radius: 5px;
    text-align: center;
    padding: 2px;
}

.bg_finish {
    background: rgba(19, 103, 0, 0.362);
    color: rgb(19, 103, 0);
}

.bg_process {
    background: rgb(255, 183, 0);
    color: rgb(255, 255, 255);
}

.bg_open {
    background: rgba(0, 196, 49, 0.362);
    color: rgb(17, 114, 0);
}

.bg_transit {
    background: rgba(0, 98, 196, 0.362);
    color: rgb(0, 49, 114);
}

.bg_admin {
    background: rgba(0, 136, 255, 0.362);
    color: rgb(0, 140, 255);
}

.bg_facturacion {
    background: rgb(255, 183, 0);
    color: rgb(255, 255, 255);
}

.bg_operador {
    background: rgba(0, 196, 49, 0.362);
    color: rgb(17, 114, 0);
}

.item-number {
    width: 90%;
    background: rgb(0, 199, 99);
    color: white;
    text-align: center;
    cursor: pointer;
    border: 1px solid rgb(0, 199, 99);
    border-radius: 12px;
    box-shadow: 0px 2px 4px rgb(211, 211, 211);
    padding: 10px;
}
</style>
